import axios from "axios";
export default{
	checkBarcode(barcode){

		console.log("checkBarcode")

		// Call to Android App
		if (window.nativeApp){
				return window.nativeApp.checkBarcode(barcode);
		}
		// Call to IOS App - ha lenne valaki,aki
		else  if ((window.webkit) && ( window.webkit.messageHandlers) && (( window.webkit.messageHandlers.nativeApp))) {
				//window.webkit.messageHandlers.nativeApp.postMessage({"openCamera": {}}); 
		}
		// nincs applikáció, böngészőből fut
		else{
				console.log("No native app wrapper found");
		}

	},
	checkPlace(barcode){

		console.log("checkPlace")

		// Call to Android App
		if (window.nativeApp){
				return window.nativeApp.checkPlace(barcode);
		}
		// Call to IOS App - ha lenne valaki,aki
		else  if ((window.webkit) && ( window.webkit.messageHandlers) && (( window.webkit.messageHandlers.nativeApp))) {
				//window.webkit.messageHandlers.nativeApp.postMessage({"openCamera": {}}); 
				console.log("iOS app wrapper found");
		}
		// nincs applikáció, böngészőből fut
		else{
				console.log("No native app wrapper found");
		}

	},
	checkPlaceDummy(barcode){
		console.log(barcode);
		return 2;
	},

	getDeviceId(){
		//return 533;
		
		if(window.nativeApp == null){
			return 533; //false
		}
		let device_id = window.nativeApp.getDeviceID();
		return device_id;
		
	},
	
	setDeviceId(device_id){
		window.nativeApp.setDeviceID(device_id);
	},
	
	initializeBarcodeList(url){
		return window.nativeApp.initializeBarcodeList(url);
	},
	
	finishPlace(project_id, lszsz, lth, device, opened_at){
		return window.nativeApp.finishPlace(project_id, lszsz, lth, device, opened_at);
	},
	
	finishCheck(project_id, lszsz, lth, device, opened_at){
		return window.nativeApp.finishCheck(project_id, lszsz, lth, device, opened_at);
	},
	
	processUploadList(project_id){
		console.log('van')
		return window.nativeApp.processUploadList(project_id);
	},
	
	showUploadList(project_id){
		console.log('fut a show upload list');
		let re = window.nativeApp.showUploadList(project_id);
		return JSON.parse(re);
	},
	
	barcodeDummy(){
		let percentage = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
		let dasIntervale = setInterval(function(){
			if(percentage >= 80){
				window.updatePercentage(100);
				clearInterval(dasIntervale);
			}else{
				window.updatePercentage(percentage);
				percentage = Math.floor(Math.random() * (100 - 0 + 1)) + 0;
			}
		}, 2000);
	},
	
	storeAmountDummy(barcode,amount){
		console.log('- store barcode: '+barcode+' amount: '+amount);
		return true;
	},
	
	storeAmount(barcode, amount, comment, discount,scanned_at){
		console.log(scanned_at);
		return window.nativeApp.storeAmount(barcode, amount, comment, discount,scanned_at);
	},
	
	storeBackup(project_id, lszsz, place_barcode, barcode, amount, scanned_at, itemName){
		return window.nativeApp.storeBackup(project_id, lszsz, place_barcode, barcode, amount, scanned_at, itemName);
	},
	
	setPlaceStatus(lth_id,place_status_id){
		return window.nativeApp.setPlaceStatus(lth_id,place_status_id);
	},
	
	storeCheck(line_number, barcode, amount, comment, discount, checked_at, iid){
		console.log('checkitem sent to appservice: '+amount,line_number, barcode, amount, comment, discount, checked_at, iid);
		return window.nativeApp.storeCheck(line_number, barcode, amount, comment, discount, checked_at, iid);
	},

	getBackupFiles(project_id){
		return window.nativeApp.getBackupFiles(project_id);
	},

	
	loadBackupFile(filename){
		return window.nativeApp.loadBackupFile(filename);
	},

	playAndroidSound(sound){
		return window.nativeApp.playAndroidSound(sound);
	},

	terminateApp()
	{
		return window.nativeApp.terminateApp();
	},
	
	async getInventoryTable(project_id,lszsz,device_id){		
		console.log(project_id,lszsz,device_id);
		return axios.post(process.env.VUE_APP_BACKEND_URL + '/tc26api/get-inventory-table/',{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},

	async getTempo(project_id,lszsz,device_id){		
		console.log(project_id,lszsz,device_id);
		return axios.post(process.env.VUE_APP_BACKEND_URL + '/tc26api/get-tempo/',{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
	
	
	async checkCheckingPlace(barcode,project_id,lszsz,device_id){		
		console.log(project_id,lszsz,device_id);
		return axios.post(process.env.VUE_APP_BACKEND_URL + '/tc26api/check-checking-place/'+barcode,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
	
	async checkStatusPlace(barcode,project_id,lszsz,device_id){
		console.log(project_id,lszsz,device_id);
		return axios.post(process.env.VUE_APP_BACKEND_URL + '/tc26api/check-status-place/'+barcode,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},

	async getStatusPlace(barcode,project_id,lszsz,device_id){
		console.log(project_id,lszsz,device_id);
		return axios.post(process.env.VUE_APP_BACKEND_URL + '/tc26api/get-status-place/'+barcode,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
	
	async setQuickPlace(barcode,project_id,lszsz,device_id){
		console.log(project_id,lszsz,device_id);
		return axios.post(process.env.VUE_APP_BACKEND_URL + '/tc26api/set-quick-place/'+barcode,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
	
	async getFinishedPlaces(timestamp,project_id,lszsz,device_id){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/get-finished-places/"+timestamp,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},
	
	async isWorkerOnBreak(project_id,lszsz,device_id){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/is-worker-on-break/"+lszsz,{
			'project_id':project_id,
			'lszsz':lszsz,
			'device':device_id
		});
	},

	async getRecordedItems(project_id,lszsz,device_id,serverParams){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/recorded-items",{
			project_id:project_id,
			lszsz:lszsz,
			device:device_id,
			serverParams:serverParams
		});
	},

	async getBreakList(project_id,lszsz,device_id){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/get-break-list",{
			project_id:project_id,
			lszsz:lszsz,
			device:device_id
		});
	},

	async setUserBreak(project_id,lszsz,device_id,lszsz_id,status){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/set-user-break",{
			project_id:project_id,
			lszsz:lszsz,
			device:device_id,
			lszsz_id:lszsz_id,
			status:status
		});
	},

	async getPlaceDetails(project_id,lszsz,device_id,lth_id){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/get-place-details",{
			project_id:project_id,
			lszsz:lszsz,
			device:device_id,
			lth_id:lth_id,
		});
	},

	async getDeviceList(project_id,lszsz,device_id){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/get-device-list",{
			project_id:project_id,
			lszsz:lszsz,
			device:device_id,
		});
	},

	async setDeviceStatus(project_id,lszsz,device_id,manual_id,isAtProject){
		return axios.post(process.env.VUE_APP_BACKEND_URL + "/tc26api/set-device-status",{
			project_id:project_id,
			lszsz:lszsz,
			device:device_id,
			manual_id:manual_id,
			isAtProject:isAtProject,
		});
	},
} 